// removed by extract-text-webpack-plugin
module.exports = {"card-container":"_3ikbk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedCard.less
// module id = ./src/components/Home/FeaturedCard.less
// module chunks = 2